export class SelectDropdownModel {
  label: String = "";
  value: String = "";
}